export default __webpack_public_path__ + "static/media/esgailogo_black.24c29e17.png";